var f = Object.defineProperty;
var l = (r, t, e) => t in r ? f(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e;
var n = (r, t, e) => (l(r, typeof t != "symbol" ? t + "" : t, e), e);
import { HubConnectionBuilder as d, LogLevel as u } from "@microsoft/signalr";
import { SignalRMethodName as h } from "@ancon/wildcat-types";
import a from "../shared/wait.mjs";
import g from "../api/generateBackoffWithEqualJitter.mjs";
import "../number/randomIntFromInterval.mjs";
class L {
  constructor(t) {
    n(this, "internalEvents");
    n(this, "signalREvents");
    n(this, "hubConnection");
    n(this, "clientId");
    n(this, "logger");
    n(this, "backoff", []);
    n(this, "reconnectAttempt", 0);
    n(this, "shouldReconnect", !0);
    n(this, "groups");
    n(this, "info", (t, e) => {
      var i;
      (i = this.logger) == null || i.info(t, e);
    });
    n(this, "generateBackoff", () => {
      this.backoff = g(50, 500, 5e3), this.info("Generated new backoff");
    });
    n(this, "reconnect", async () => {
      if (this.shouldReconnect)
        try {
          this.info("Attempting to reconnect...", {
            attempt: this.reconnectAttempt + 1
          }), await this.connect(!0), this.info("Reconnected"), this.reconnectAttempt = 0;
        } catch {
          if (this.backoff[this.reconnectAttempt] != null) {
            const e = this.backoff[this.reconnectAttempt];
            if (e != null)
              await a(e);
            else
              throw new Error("Could not resolve ms from backoff");
          } else {
            this.reconnectAttempt > 0 && this.info("Ran out of backoff intervals, restarting backoff..."), this.reconnectAttempt = 0, this.generateBackoff();
            const e = this.backoff[this.reconnectAttempt];
            if (e != null)
              await a(e);
            else
              throw new Error("Could not resolve ms from backoff");
          }
          this.reconnectAttempt += 1, await this.reconnect();
        }
    });
    n(this, "buildInitialListeners", () => {
      this.hubConnection.onclose(() => {
        this.groups = [], this.info("Hub connection closed"), this.emitEvent("disconnected"), this.reconnect();
      }), this.hubConnection.onreconnected(() => this.emitEvent("reconnected"));
    });
    /**
     * Emit event
     * @param event Event to emit
     * @param args Arguments to send to the listeners
     */
    n(this, "emitEvent", (t, ...e) => {
      if (this.internalEvents.has(t)) {
        this.info(`Emitting event "${t}"`);
        const i = this.internalEvents.get(t);
        i && i.forEach((s) => s(...e));
      } else
        this.info(`Failed to emit event "${t}". There were no listeners.`);
    });
    n(this, "skipSignal", (t, e) => {
      this.info(`Skipped signal "${t}"`, e);
    });
    n(this, "enhanceListener", (t, e, i) => (s) => {
      const o = JSON.parse(s), c = i && o.clientId && o.clientId === this.clientId;
      return c || this.info(`Received signal "${t}"`, s), c ? this.skipSignal(t, s) : e(o);
    });
    n(this, "setClientId", (t) => {
      this.clientId = t;
    });
    n(this, "connect", async (t = !1) => {
      try {
        this.info("Connecting..."), await this.hubConnection.start(), this.info("Connected"), this.emitEvent("connected");
      } catch (e) {
        if (this.info("Failed to connect"), t)
          throw e;
      }
    });
    n(this, "disconnect", async () => {
      try {
        this.shouldReconnect = !1, this.info("Disconnecting..."), await this.hubConnection.stop(), this.info("Disconnected"), this.emitEvent("disconnected");
      } catch {
        this.info("Failed to disconnect");
      }
    });
    /**
     * Add internal event listener
     * @param event Event to listen on
     * @param listener Event listener function
     */
    n(this, "addEventListener", (t, e) => {
      this.internalEvents.has(t) || this.internalEvents.set(t, []);
      const i = this.internalEvents.get(t);
      return i && i.push(e), () => this.removeEventListener(t, e);
    });
    /**
     * Remove internal event listener
     * @param event Event to stop listening to
     * @param listener Event listener function
     */
    n(this, "removeEventListener", (t, e) => {
      var i;
      if (this.internalEvents.has(t)) {
        const s = this.internalEvents.get(t), o = ((i = s == null ? void 0 : s.indexOf) == null ? void 0 : i.call(s, e)) ?? -1;
        o >= 0 ? (s.splice(o, 1), this.info(`Removed event listener for event "${t}"`)) : this.info(
          `Failed to remove event listener for event "${t}". Specified listener was not found.`
        );
      } else
        this.info(
          `Failed to remove event listener for event "${t}". Event doesn't have any listeners.`
        );
    });
    /**
     * Add signal listener
     * @param signal Signal name
     * @param listener Signal listener function
     */
    n(this, "addSignalListener", (t, e, i = !0) => {
      this.signalREvents.has(t) || this.signalREvents.set(t, []);
      const s = this.signalREvents.get(t), o = this.enhanceListener(
        t,
        e,
        i
      );
      return s && s.push(o), this.hubConnection.on(t, o), this.info(`Added signal listener for signal "${t}"`), () => this.removeSignalListener(t, o);
    });
    /**
     * Remove signal listener
     * @param signal Signal name
     * @param listener Signal listener function
     */
    n(this, "removeSignalListener", (t, e) => {
      var i;
      if (this.signalREvents.has(t)) {
        const s = this.signalREvents.get(t), o = ((i = s == null ? void 0 : s.indexOf) == null ? void 0 : i.call(s, e)) ?? -1;
        o >= 0 ? (this.hubConnection.off(t, e), s.splice(o, 1), this.info(`Removed signal listener for signal "${t}"`)) : this.info(
          `Failed to remove signal listener for signal "${t}". Specified listener was not found.`
        );
      } else
        this.info(
          `Failed to remove signal listener for signal "${t}". Signal doesn't have any listeners.`
        );
    });
    n(this, "joinGroup", async (t) => {
      this.info(`Joining group "${t}"...`);
      const e = this.groups.push(t) - 1;
      try {
        await this.hubConnection.invoke(h.JoinGroup, t), this.info(`Joined group "${t}"`);
      } catch (i) {
        this.info(`Failed to join group "${t}"`, i), e >= 0 && this.groups.splice(e, 1);
      }
    });
    n(this, "leaveGroup", async (t) => {
      this.info(`Leaving group "${t}"...`);
      const e = this.groups.indexOf(t);
      e >= 0 && this.groups.splice(e, 1);
      try {
        await this.hubConnection.invoke(h.LeaveGroup, t), this.info(`Left group "${t}"`);
      } catch (i) {
        this.groups.indexOf(t) < 0 && this.groups.push(t), this.info(`Failed to leave group "${t}"`, i);
      }
    });
    n(this, "leaveAllGroups", async () => {
      this.info(`Leaving all (${this.groups.length}) groups...`);
      const t = [...this.groups].map((e) => this.leaveGroup(e));
      await Promise.all(t), this.info("Left all groups");
    });
    n(this, "getHubConnectionId", () => this.hubConnection.connectionId);
    this.internalEvents = /* @__PURE__ */ new Map(), this.signalREvents = /* @__PURE__ */ new Map(), this.groups = [], t.enableLogging && (this.logger = t.logger), this.hubConnection = new d().withUrl(`${t.signalRApiUrl}/${t.hub}`).configureLogging(u.None).build(), this.buildInitialListeners();
  }
}
export {
  L as default
};
